import { Box } from '@mui/material';
import check from 'assets/svg/check.svg';
interface ICartCheckboxProps {
    checked: boolean;
    handleCheck?: () => void;
}

const CartCheckbox = ({ checked, handleCheck }: ICartCheckboxProps) => {
    return (
        <Box
            display="flex"
            alignItems="center"
            width="25px"
            justifyContent="center"
            height="25px"
            onClick={() => handleCheck?.()}
            sx={{
                backgroundColor: checked ? 'primary.main' : 'white',
                borderRadius: '50px',
                cursor: 'pointer',
                border: '3px solid #009DE0',
            }}
        >
            {checked && <img src={check} width="15px" />}
        </Box>
    );
};

export default CartCheckbox;
